import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    card: {
        boxShadow: "none",
        backgroundColor: theme.palette.background.main,
        padding: theme.spacing(2),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            padding: theme.spacing(1),
        },
    },
    canGetBroadbandButton: {
        marginTop: theme.spacing(2),
    },
}));
